import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GsLoginComponent } from './gs-login.component';
import {HttpClientModule} from '@angular/common/http';
import { Auth } from './model';
import { GsLoginService } from './gs-login.service';


@NgModule({
  declarations: [GsLoginComponent],
  imports: [
    ReactiveFormsModule,
    HttpClientModule
  ],
  exports: [GsLoginComponent]
})
export class GsLoginModule {
  static forRoot(authConfig:Auth):ModuleWithProviders<GsLoginModule>{
    return {
      ngModule:GsLoginModule,
      providers:[GsLoginService,{provide:'authConfig',useValue:authConfig}]
    }
  }
 }
